import { render, staticRenderFns } from "./TextAroundQrCodeSettings.vue?vue&type=template&id=441e7581&scoped=true"
import script from "./TextAroundQrCodeSettings.vue?vue&type=script&lang=js"
export * from "./TextAroundQrCodeSettings.vue?vue&type=script&lang=js"
import style0 from "./TextAroundQrCodeSettings.vue?vue&type=style&index=0&id=441e7581&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441e7581",
  null
  
)

export default component.exports